import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Icon from '../../../base/icons/components/Icon';
import { IconArrowBack, IconCloseLarge } from '../../../base/icons/svg';
import { toggleChat } from '../../actions.web';
/**
 * Custom header of the {@code ChatDialog}.
 *
 * @returns {React$Element<any>}
 */
function ChatHeader({ className, isPollsEnabled }) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const onCancel = useCallback(() => {
        dispatch(toggleChat());
    }, []);
    const onKeyPressHandler = useCallback(e => {
        if (onCancel && (e.key === ' ' || e.key === 'Enter')) {
            e.preventDefault();
            onCancel();
        }
    }, []);
    // On phones chat covers the whole call — give an obvious way back.
    const isSmallScreen = typeof window !== 'undefined' && window.innerWidth <= 580;
    return (React.createElement("div", { className: className || 'chat-dialog-header' },
        isSmallScreen && (React.createElement("span", { "aria-label": 'Back to meeting', onClick: onCancel, onKeyPress: onKeyPressHandler, role: 'button', style: {
                alignItems: 'center',
                cursor: 'pointer',
                display: 'inline-flex',
                gap: '6px',
                marginRight: '12px',
                whiteSpace: 'nowrap'
            }, tabIndex: 0 },
            React.createElement(Icon, { size: 20, src: IconArrowBack }),
            "Back to meeting")),
        React.createElement("span", { "aria-level": 1, role: 'heading', style: isSmallScreen ? { flex: 1, textAlign: 'center' } : undefined }, t(isPollsEnabled ? 'chat.titleWithPolls' : 'chat.title')),
        React.createElement(Icon, { ariaLabel: t('toolbar.closeChat'), onClick: onCancel, onKeyPress: onKeyPressHandler, role: 'button', src: IconCloseLarge, tabIndex: 0 })));
}
export default ChatHeader;
